import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const TalentMetricsChart = ({ data, title }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-executive">
          <p className="font-medium text-text-primary">{label}</p>
          {payload.map((entry, index) => (
            <p key={index} className="text-sm" style={{ color: entry.color }}>
              {entry.dataKey}: {entry.value.toLocaleString()}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="card-elevated p-6">
      <h3 className="font-headline font-semibold text-xl text-text-primary mb-6">{title}</h3>
      <div className="h-80 w-full flex items-center justify-center">
        <BarChart width={Math.min(window.innerWidth - 100, 800)} height={320} data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="city" 
              tick={{ fill: 'var(--color-text-secondary)', fontSize: 12 }}
              axisLine={{ stroke: 'var(--color-border)' }}
            />
            <YAxis 
              tick={{ fill: 'var(--color-text-secondary)', fontSize: 12 }}
              axisLine={{ stroke: 'var(--color-border)' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <Bar 
              dataKey="available" 
              fill="var(--color-cta)" 
              name="Available Talent"
              radius={[4, 4, 0, 0]}
            />
            <Bar 
              dataKey="demand" 
              fill="var(--color-accent)" 
              name="Market Demand"
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
      </div>
    </div>
  );
};

export default TalentMetricsChart;